class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.boundOnFocusOut = this.onFocusOut.bind(this);
    this.mainDetailsToggle.addEventListener('focusout', this.boundOnFocusOut);
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Remove focusout listener entirely for hover menus
    this.mainDetailsToggle.removeEventListener('focusout', this.boundOnFocusOut);

    // Intercept summary click to prevent native toggle fighting our logic
    const summary = this.mainDetailsToggle.querySelector('summary');
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.close();
      } else {
        this.mainDetailsToggle.setAttribute('open', '');
        summary.setAttribute('aria-expanded', true);
      }
    });

    // Use a delay on mouseleave so moving into the submenu doesn't close it
    this.addEventListener('mouseleave', () => {
      this._closeTimer = setTimeout(() => this.close(), 300);
    });
    this.addEventListener('mouseenter', () => {
      clearTimeout(this._closeTimer);
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position0desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
